<nav class="legal-navbar">
  <ul class="legal-navbar__list">
    <li class="legal-navbar__item" *ngFor="let item of links">
      <a [routerLink]="item.link" routerLinkActive="legal-navbar__link-active"
        class="legal-navbar__link">{{item.title}}</a>
    </li>
  </ul>
</nav>